import {WBIcon} from '@wandb/ui';
import {
  WBButton,
  WBButtonLink,
} from '@wandb/weave/common/components/elements/WBButtonNew';
import * as globals from '@wandb/weave/common/css/globals.styles';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const SelectShowcaseButton = styled(WBButton)``;

export const ViewAllLink = styled(WBButtonLink)``;

export const ViewAllIcon = styled(WBIcon).attrs({name: `right-arrow`})`
  font-size: calc(${globals.fontSizeStandard} * 1.5);
  margin-left: calc(${globals.spu} * 1);
`;
